import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { GlobalVariables } from 'app/services/globals';
import { LinkedServiceUtils } from './linked-service.utils';

@Metamodel.model({
    name: 'Shopify',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Shopify_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Shopify_DisplayText)
    ]
})
export class ShopifyLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: string = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessToken,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public accessToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseHostVerification
    })
    public useHostVerification?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UsePeerVerification
    })
    public usePeerVerification?: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);
        
        if (GlobalVariables.enableShopifyV2 && __IS_FABRIC_DPE__) {
            this.version = driverVersions.v2;
        }
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): ShopifyLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as ShopifyLinkedService;
    }
}
